import e from "./_nativeCreate.js";
var n = e, _ = "__lodash_hash_undefined__", o = Object.prototype, d = o.hasOwnProperty;
function h(a) {
  var r = this.__data__;
  if (n) {
    var t = r[a];
    return t === _ ? void 0 : t;
  }
  return d.call(r, a) ? r[a] : void 0;
}
var v = h;
export {
  v as default
};
//# sourceMappingURL=_hashGet.js.map
